import React, { useRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./Home.css";
import { FaMicrochip, FaDatabase, FaUserTie, FaShieldAlt, FaTools, FaMoneyBill, FaUserCog, FaEye, FaDesktop, FaChalkboardTeacher, FaRocket, FaBrain, FaGlobe, FaHandshake, FaIndustry, FaServer, FaNetworkWired, FaUsers } from "react-icons/fa";
import Footer from "../../components/Footer";
import imageService from "../../services/imageService";
import cacheService from "../../services/cacheService";
import IOSInstallPrompt from "../../components/IOSInstallPrompt";
import AndroidInstallPrompt from "../../components/AndroidInstallPrompt";
import { getInstallPlatform } from "../../utils/iosDetection";
import grcImage from '../../assets/Products/GRC/GRCS.jpg';
import logger from '../../utils/logger';
import { preloadAllImages } from '../../utils/imagePreloader';
import financeImage from '../../assets/Home/Finance 1.jpg';
import aboutUsVideo from '../../assets/Home/About Us.mp4';
import proSyncVideo from '../../assets/Home/ProSync.mp4';
import lapsecVideo from '../../assets/Home/Victaa.mp4';
import grcVideo from '../../assets/Home/Riskavaire GRC.mp4';
import tprmVideo from '../../assets/Home/Riskavaire TPRM.mp4';
import tprmLogo from '../../assets/Home/Riskavaire_TPRM trimmed.png';
import riskavaireGrcLogo from '../../assets/Home/Riskavaire_GRC trimmed.png';
import prosyncLogo from '../../assets/Home/PROSYNC_Logo trimmed.png';
import victaaLogo from '../../assets/Home/Victaa_Logo trimmed.png';
import fostHrVideo from '../../assets/Home/FostHR.mp4';
import fostHrLogo from '../../assets/Home/FostHR trimmed.png';
import smartCashflowVideo from '../../assets/Home/Smart Cashflow.mp4';
import smartCashflowLogo from '../../assets/Home/SMART_CASHFLOW trimmed.png';
import IntechsanteCarouselSlide from './IntechsanteCarouselSlide';
import GrcWebinarCarouselSlide from './GrcWebinarCarouselSlide';
import vardaanVLogo from '../../assets/Home/Vardaan V icon.png';
import dataServicesHero from '../../assets/images/Data Services/development.avif';
import aiConsultingHero from '../../assets/images/AI Consulting services/AI Consulting Hero.avif';
import erpServicesHero from '../../assets/images/ERP Services/Oracle ERP Services.avif';
import technoFinancialHero from '../../assets/images/Techno Financial Services/Business-and-Plant-Valuations.avif';
import cyberSecurityHero from '../../assets/images/Cyber Security/breach-simulation.avif';
import trainingHero from '../../assets/images/Training/Training.webp';
import dataCenterImg from '../../assets/Products/Services/Data center.jpg';
import integratedITImg from '../../assets/Products/Services/Integrated IT.webp';
import aiInfrastructureImg from '../../assets/Products/Services/AI Infrastruture.webp';
import workforceManagementImg from '../../assets/Products/Services/Workforce Management.jpg';


// Fallback images (only used if S3 images fail to load)
const inlineFallbackImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='900'%3E%3Crect width='100%25' height='100%25' fill='%23e5e7eb'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%236b7280' font-family='Arial' font-size='36'%3EImage unavailable%3C/text%3E%3C/svg%3E";
const PUBLIC_ASSET_BASE = process.env.PUBLIC_URL || '';
const RELATIVE_ASSET_BASE = PUBLIC_ASSET_BASE || '.';

const fallbackImages = {
  'aboutus1.jpg': `${PUBLIC_ASSET_BASE}/aboutus1.jpg`,
  'AI Products.jpg': inlineFallbackImage,
  'Data Services.avif': inlineFallbackImage,
  'Ai Consulting.jpg': inlineFallbackImage,
  'Cyber security.avif': inlineFallbackImage,
  'ERP.jpg': inlineFallbackImage,
  'Techno Financial Services.webp': inlineFallbackImage,
  'Digital Workers.jpg': inlineFallbackImage,
  'Vision.jpg': inlineFallbackImage,
  'Corporate.jpg': inlineFallbackImage,
  'Training.webp': inlineFallbackImage,
  'training-ds.webp': inlineFallbackImage,
  'training-cyber.jpg': inlineFallbackImage,
  'Technology.jpg': inlineFallbackImage,
  'Data.jpeg': inlineFallbackImage,
  'consulting.jpg': inlineFallbackImage,
  'cyber-security.jpg': inlineFallbackImage,
  'Training.jpg': inlineFallbackImage,
  'resources.webp': inlineFallbackImage,
  'Strategy.webp': inlineFallbackImage,
  'micro-arrow.jpg': inlineFallbackImage,
  'erp-cloud-integration.webp': inlineFallbackImage,
  'robotics.jpeg': inlineFallbackImage,
  'Digi work.jpg': inlineFallbackImage,
  'Visual Ai.avif': inlineFallbackImage,
  'GRCS.jpg': require('../../assets/Products/GRC/GRCS.jpg')
};

// Videos - use PUBLIC_URL-aware local paths as final fallback.
const videoUrls = {
  heroVideo1: aboutUsVideo,
  lapsecVideo,
  auditVideo: proSyncVideo,
  grcVideo,
  tprmVideo,
  fostHrVideo,
  smartCashflowVideo
};

const portfolioItems = [
  { icon: <FaDatabase />, label: "DATA SERVICES" },
  { icon: <FaBrain />, label: "AI CONSULTING SERVICES" },
  { icon: <FaTools />, label: "ERP – ORACLE SERVICES" },
  { icon: <FaMoneyBill />, label: "TECHNO-FINANCIAL SERVICES" },
  { icon: <FaShieldAlt />, label: "CYBERSECURITY SERVICES" },
  { icon: <FaChalkboardTeacher />, label: "TRAINING" },
  { icon: <FaServer />, label: "DATA CENTRE COLOCATION & HARDWARE" },
  { icon: <FaNetworkWired />, label: "INTEGRATED IT (DC FIELD SERVICES & ITAD)" },
  { icon: <FaMicrochip />, label: "AI INFRASTRUCTURE & GPUAAS" },
  { icon: <FaUsers />, label: "WORKFORCE MANAGEMENT & STAFF AUGMENTATION" },
];

const productMarqueeItems = [
  { name: "Riskavaire GRC", tagline: "Governance, risk & compliance intelligence", logo: riskavaireGrcLogo, path: "https://vardaands.com/riskavaire", isExternal: true },
  { name: "Riskavaire TPRM", tagline: "Third-party risk, simplified", logo: tprmLogo, path: "https://vardaands.com/tprm", isExternal: true },
  { name: "ProSync", tagline: "Workflow automation that never sleeps", logo: prosyncLogo, path: "https://vardaands.com/prosync", isExternal: true },
  { name: "ViCTAA", tagline: "Endpoint privilege & access control", logo: victaaLogo, path: "https://vardaands.com/ViCTAA", isExternal: true },
  { name: "FostHR", tagline: "One platform for the entire workforce", logo: fostHrLogo, path: "/fost-hr", isExternal: false },
  { name: "Smart Cashflow", tagline: "Financial intelligence & forecasting", logo: smartCashflowLogo, path: "https://vardaands.com/smartcashflow", isExternal: true },
];


const homeServices = [
  { id: 'data-services', title: 'DATA SERVICES', route: 'https://vardaands.com/', image: dataServicesHero, description: 'Complete data lifecycle management including integration, governance, and advanced analytics capabilities.' },
  { id: 'ai-consulting', title: 'AI CONSULTING SERVICES', route: 'https://exaliotech.com/', image: aiConsultingHero, description: 'Strategy, design, and deployment of measurable AI solutions that unlock automation and ROI.' },
  { id: 'erp-oracle', title: 'ERP – ORACLE SERVICES', route: 'https://infodriveanalytics.com/', image: erpServicesHero, description: 'Modernize Oracle ERP Cloud and on-prem ecosystems with proven implementation and managed pods.' },
  { id: 'techno-financial', title: 'TECHNO-FINANCIAL SERVICES', route: 'https://vardaanresources.com/', image: technoFinancialHero, description: 'Engineering-led advisory that blends product innovation, investment insights, and digital execution.' },
  { id: 'cybersecurity', title: 'CYBERSECURITY SERVICES', route: 'https://www.vardaan-cyber.com/', image: cyberSecurityHero, description: 'Red teaming, vCISO, and incident response programs that secure mission-critical operations.' },
  { id: 'training', title: 'TRAINING', route: 'https://www.vardaan-cyber.com/professional-training', image: trainingHero, description: 'Role-ready learning paths and certifications across cyber, data, and intelligent automation.' },
  { id: 'data-centre', title: 'DATA CENTRE COLOCATION & HARDWARE', route: null, image: dataCenterImg, description: 'Colocation, hardware sourcing & 24/7 managed operations across APAC data-centre partners.' },
  { id: 'integrated-it', title: 'INTEGRATED IT, DC FIELD SERVICES & ITAD', route: null, image: integratedITImg, description: 'Desktop to data centre — service desk, remote & smart hands, rack & stack, secure ITAD.' },
  { id: 'ai-infrastructure', title: 'AI INFRASTRUCTURE & GPUAAS', route: null, image: aiInfrastructureImg, description: 'On-demand NVIDIA & AMD GPU compute for training, fine-tuning & inference.' },
  { id: 'workforce-management', title: 'WORKFORCE MANAGEMENT & STAFF AUGMENTATION', route: null, image: workforceManagementImg, description: 'Vetted specialist talent, managed delivery teams & workforce governance.' },
];

const AnimatedHeroTitle = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);
  const titleRef = useRef(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.5 }
    );
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <h1 ref={titleRef} className={`hero-title-animated${isVisible ? " hero-title-animated--visible" : ""}`}>
      {text.split("").map((char, idx) => (
        char === "V" && idx === 0 ? (
          <span
            key={idx}
            className="hero-title-letter hero-title-v-red"
            style={isVisible ? { animationDelay: `${idx * 0.07 + 0.2}s` } : {}}
          >
            {char}
          </span>
        ) : (
          <span
            key={idx}
            className="hero-title-letter"
            style={isVisible ? { animationDelay: `${idx * 0.07 + 0.2}s` } : {}}
          >
            {char === " " ? "\u00A0" : char}
          </span>
        )
      ))}
    </h1>
  );
};

const AnimatedHeroTagline = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);
  const taglineRef = useRef(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.5 }
    );
    if (taglineRef.current) {
      observer.observe(taglineRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <p ref={taglineRef} className={`hero-subtext-animated${isVisible ? " hero-subtext-animated--visible" : ""} hero-subtext`}>
      {text.split(" ").map((word, idx) => (
        <span
          key={idx}
          className="hero-tagline-word"
          style={isVisible ? { animationDelay: `${idx * 0.25 + 0.2}s` } : {}}
        >
          {word + (idx !== text.split(" ").length - 1 ? "\u00A0" : "")}
        </span>
      ))}
    </p>
  );
};

const AboutAnimatedDescription = ({ text }) => {
  const [visibleSentences, setVisibleSentences] = useState([]);
  const descRef = useRef(null);
  const sentences = text.match(/[^.!?]+[.!?]+/g) || [text];

  useEffect(() => {
    let timeouts = [];
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sentences.forEach((_, idx) => {
            const timeout = setTimeout(() => {
              setVisibleSentences((prev) => {
                if (!prev.includes(idx)) return [...prev, idx];
                return prev;
              });
            }, idx * 600);
            timeouts.push(timeout);
          });
        } else {
          setVisibleSentences([]);
          timeouts.forEach(clearTimeout);
        }
      },
      { threshold: 0.3 }
    );
    if (descRef.current) observer.observe(descRef.current);
    return () => {
      observer.disconnect();
      timeouts.forEach(clearTimeout);
    };
  }, [sentences]);

  return (
    <p className="about-img-desc" ref={descRef}>
      {sentences.map((sentence, idx) => (
        <span
          key={idx}
          className={`about-desc-sentence${visibleSentences.includes(idx) ? ' about-desc-sentence--visible' : ''}`}
        >
          {sentence.trim()}&nbsp;
        </span>
      ))}
    </p>
  );
};

const Home = () => {
  const history = useHistory();
  const parallaxBgRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeCard, setActiveCard] = useState(null);
  const [hoverSection, setHoverSection] = useState(null);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [failedVideoSlides, setFailedVideoSlides] = useState({});
  const heroSectionRef = useRef(null);
  
  // State for database images and videos - Set to loaded immediately to show content
  const [dbImages, setDbImages] = useState({});
  const [dbVideos, setDbVideos] = useState({});
  const [imagesLoaded, setImagesLoaded] = useState(true); // Set to true immediately
  const [videosLoaded, setVideosLoaded] = useState(true); // Set to true immediately
  const [imageLoadError, setImageLoadError] = useState(false);
  const [videoLoadError, setVideoLoadError] = useState(false);
  
  // Touch/swipe state
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // PWA install state (desktop, Android, iOS)
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const deferredPromptRef = useRef(null);
  const [installPlatform, setInstallPlatform] = useState(null);
  const [isBannerDismissed, setIsBannerDismissed] = useState(false);
  const [showIOSPrompt, setShowIOSPrompt] = useState(false);
  const [showAndroidPrompt, setShowAndroidPrompt] = useState(false);

  // Load images and videos from database WITH CACHING (NON-BLOCKING)
  const loadMediaFromDatabase = async () => {
    const MEDIA_CACHE_KEY = 'vardaan_home_media_processed_v2';
    
    // CRITICAL: Set loaded immediately so local images show right away
    setImagesLoaded(true);
    setVideosLoaded(true);
    
    // Load S3 URLs in background (non-blocking enhancement)
    try {
      // 1. TRY CACHE FIRST (for processed data)
      const cachedMedia = await cacheService.getCache(MEDIA_CACHE_KEY);
      if (cachedMedia) {
        logger.log('✅ Home: Loaded processed media from cache!');
        const cachedImageMap = cachedMedia.imageMap || {};
        const cachedVideoMap = { ...(cachedMedia.videoMap || {}) };

        setDbImages(cachedImageMap);
        setDbVideos(cachedVideoMap);
        return; // Exit early - no need to fetch or process
      }
      
      // 2. IF NO CACHE, FETCH FROM API (non-blocking)
      const response = await imageService.getAllImages();
      
      if (response.success && response.data) {
        const imageMap = {};
        const videoMap = {};
        
        // Create maps of media names to their S3 URLs
        response.data.forEach((media) => {
          const mediaUrl = media.url || media.s3_url;
          if (media.original_name && mediaUrl) {
            // Check if it's a video file
            const isVideo = media.original_name.toLowerCase().match(/\.(mp4|webm|ogg|mov|avi)$/);
            if (isVideo) {
              videoMap[media.original_name] = mediaUrl;
            } else {
              imageMap[media.original_name] = mediaUrl;
            }
          }
        });
        
        // SAVE PROCESSED DATA TO CACHE
        await cacheService.setCache(MEDIA_CACHE_KEY, {
          imageMap,
          videoMap
        });
        
        // Update state (images already showing from local assets)
        setDbImages(imageMap);
        setDbVideos(videoMap);
      } else {
        setImageLoadError(true);
        setVideoLoadError(true);
      }
    } catch (error) {
      logger.error('Error loading media from database:', error);
      setImageLoadError(true);
      setVideoLoadError(true);
    }
  };

  // Helper function to get image URL (prioritizes S3, falls back to local)
  // OPTIMIZED: Removed excessive logging, simplified logic
  const getImageUrl = (imageName, fallbackImage) => {
    // Priority 1: Try to get from S3 (database) if available
    if (imagesLoaded && !imageLoadError && dbImages[imageName]) {
      return dbImages[imageName];
    } 
    
    // Priority 2: Fallback to local assets (always available, fast)
    return fallbackImage;
  };

  // Helper function to get video URL (prioritizes S3, falls back to local)
  // OPTIMIZED: Removed excessive logging, simplified logic
  const getVideoUrl = (videoName, fallbackVideo) => {
    // Priority 1: Try to get from S3 (database) if available
    if (videosLoaded && !videoLoadError && dbVideos[videoName]) {
      return dbVideos[videoName];
    } 
    
    // Priority 2: Fallback to local assets (always available, fast)
    return fallbackVideo;
  };

  const getVideoSlide = (videoName, fallbackVideo, slideData) => {
    if (failedVideoSlides[videoName]) {
      return {
        ...slideData,
        type: "image",
        src: getImageUrl('aboutus1.jpg', fallbackImages['aboutus1.jpg'])
      };
    }

    return {
      ...slideData,
      type: "video",
      videoName,
      src: getVideoUrl(videoName, fallbackVideo)
    };
  };
  
  // Video references for all videos in the hero carousel
  const videoRefs = [
    useRef(null), // grc-webinar custom slide
    useRef(null), // heroVideo1 (Vardaan Global)
    useRef(null), // intechsante custom slide
    useRef(null), // grcVideo
    useRef(null), // tprmVideo
    useRef(null), // auditVideo
    useRef(null), // fostHrVideo
    useRef(null), // lapsecVideo
    useRef(null), // smartCashflowVideo
  ];
  
  // Define hero carousel data with paths and titles - supports both videos and images
  const getHeroVideos = () => [
    {
      type: "custom",
      slideKey: "grc-webinar",
      path: "https://events.teams.microsoft.com/event/2f5971f1-6b07-41a1-ad93-5a3b261a1073@aa7c8c45-41a3-4453-bc9a-3adfe8ff5fb6?source=copyLinkOneEventsShareDialog",
      isExternal: true,
      title: "AI-Enabled GRC — Live Webinar",
    },
    getVideoSlide('hero-overlay.mp4', videoUrls.heroVideo1, { title: "", subtitle: "Driven by Insight, Designed for Tomorrow", customClass: 'home-slide', logo: vardaanVLogo, brandText: "Vardaan Global", path: null }),
    {
      type: "custom",
      slideKey: "intechsante",
      path: "/newsroom/intechsante",
      title: "INTECHSANTÉ Medical Expo 2026",
    },
    getVideoSlide('Riskavaire GRC.mp4', videoUrls.grcVideo, { title: "", subtitle: "Transforms compliance into confidence—simplifying audits, reducing risk, and giving you control, one module at a time.", customClass: 'product-slide', logo: riskavaireGrcLogo, path: "https://vardaands.com/riskavaire", isExternal: true }),
    getVideoSlide('Riskavaire TPRM.mp4', videoUrls.tprmVideo, { title: "", subtitle: "", description: "Manage vendor risks across the entire lifecycle with intelligent assessments, continuous monitoring, multidimensional risk scoring, and audit-ready reporting.", customClass: 'tprm-slide', logo: tprmLogo, path: "https://vardaands.com/tprm", isExternal: true }),
    getVideoSlide('Audit.mp4', videoUrls.auditVideo, { title: "", subtitle: "Turn bottlenecks into breakthroughs, automate critical workflows, escalates faster, and keeps compliance running like clockwork.", customClass: 'product-slide', logo: prosyncLogo, logoClass: 'prosync-logo', path: "https://vardaands.com/prosync", isExternal: true }),
    getVideoSlide('FostHR.mp4', videoUrls.fostHrVideo, { title: "", subtitle: "Simplify workforce management with one integrated platform for recruitment, employee lifecycle management, payroll, timesheets, asset tracking, and real-time workforce analytics.", customClass: 'fost-hr-slide', logo: fostHrLogo, path: "https://vardaands.com/fosthr", isExternal: true }),
    getVideoSlide('Victaa.mp4', videoUrls.lapsecVideo, { title: "", subtitle: "Delivers airtight local access control and intelligent privilege enforcement—securing endpoints without slowing teams down.", customClass: 'product-slide', logo: victaaLogo, logoClass: 'victaa-logo', path: "https://vardaands.com/ViCTAA", isExternal: true }),
    getVideoSlide('Smart Cashflow.mp4', videoUrls.smartCashflowVideo, { title: "", subtitle: "Know Your Cashflow. Predict Your Future. Control Your Business.", customClass: 'product-slide', logo: smartCashflowLogo, path: "https://vardaands.com/smartcashflow", isExternal: true })
  ];

  // Function to navigate to the next slide
  const nextSlide = () => {
    const videos = getHeroVideos();
    setActiveSlide((prevSlide) => (prevSlide + 1) % videos.length);
  };

  // Function to navigate to the previous slide
  const prevSlide = () => {
    const videos = getHeroVideos();
    setActiveSlide((prevSlide) => (prevSlide - 1 + videos.length) % videos.length);
  };

  // Function to handle dot navigation
  const goToSlide = (index) => {
    setActiveSlide(index);
  };

  // Touch event handlers for swipe functionality
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextSlide();
    }
    if (isRightSwipe) {
      prevSlide();
    }
  };

  // Function to handle hero click - either play video or navigate to product page
  const handleHeroClick = () => {
    const videos = getHeroVideos();
    const currentVideo = videoRefs[activeSlide].current;
    
    // If it's a product video/image with a path, navigate to that path
    if (videos[activeSlide].path) {
      // Check if it's an external link
      if (videos[activeSlide].isExternal) {
        window.open(videos[activeSlide].path, '_blank', 'noopener,noreferrer');
      } else {
        history.push(videos[activeSlide].path);
      }
      return;
    }
    // Otherwise just ensure the video is playing
    else if (currentVideo) {
      currentVideo.play().catch(error => {
        console.log("Manual play error:", error);
      });
    }
  };

  // Load media from database on component mount - NON-BLOCKING
  useEffect(() => {
    // Preload all images from all pages for instant display when user navigates
    preloadAllImages();
    
    // Preload critical page bundles to eliminate "Loading..." messages
    // Preload About Vardaan page bundle
    import('../../pages/About Vardaan/About Vardaan').catch(() => {});
    // Preload Products page bundle
    import('../../pages/Products/Products').catch(() => {});
    // Preload Services page bundle
    import('../../pages/Services/Service').catch(() => {});
    
    // Load media in background - doesn't block rendering
    loadMediaFromDatabase();
  }, []);

  const isStandaloneApp = () => (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );

  // Detect install platform: desktop, android, or ios
  useEffect(() => {
    setInstallPlatform(getInstallPlatform());
  }, []);

  // Capture native install prompt for desktop and Android
  useEffect(() => {
    if (installPlatform === 'ios' || isStandaloneApp()) {
      return undefined;
    }

    const handleBeforeInstallPrompt = (e) => {
      console.log('🚀 PWA install prompt captured');
      e.preventDefault();
      deferredPromptRef.current = e;
      setDeferredPrompt(e);
    };

    const handleAppInstalled = () => {
      console.log('✅ PWA installed');
      setInstallPlatform(null);
      deferredPromptRef.current = null;
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, [installPlatform]);

  const triggerNativeInstall = async () => {
    const promptEvent = deferredPromptRef.current;
    if (!promptEvent) {
      return false;
    }

    console.log('📥 Showing native PWA install prompt');
    promptEvent.prompt();

    const { outcome } = await promptEvent.userChoice;
    console.log(`👤 User response to install prompt: ${outcome}`);

    deferredPromptRef.current = null;
    setDeferredPrompt(null);
    if (outcome === 'accepted') {
      setInstallPlatform(null);
    }

    return true;
  };

  const shouldShowInstallBanner = () => {
    if (!installPlatform || isBannerDismissed) {
      return false;
    }

    // Desktop: only show when one-click install is ready
    if (installPlatform === 'desktop') {
      return !!deferredPrompt;
    }

    return true;
  };

  // Platform-specific install handlers
  const handleInstallClick = async () => {
    switch (installPlatform) {
      case 'ios':
        console.log('📱 iOS - showing install instructions');
        setShowIOSPrompt(true);
        break;

      case 'android': {
        const androidInstalled = await triggerNativeInstall();
        if (!androidInstalled) {
          console.log('📱 Android - showing install instructions');
          setShowAndroidPrompt(true);
        }
        break;
      }

      case 'desktop':
        await triggerNativeInstall();
        break;

      default:
        break;
    }
  };

  const handleIOSPromptClose = () => setShowIOSPrompt(false);
  const handleAndroidPromptClose = () => setShowAndroidPrompt(false);

  // Handle Banner Close Button Click
  const handleBannerClose = () => {
    console.log('❌ PWA banner dismissed by user');
    setIsBannerDismissed(true);
  };

  // Force re-render when videos are loaded to update video sources
  useEffect(() => {
    if (videosLoaded) {
      console.log('🎬 Videos loaded from database, updating video sources...');
      // Force re-render by updating state
      setActiveSlide(prev => prev);
    }
  }, [videosLoaded, dbVideos]);

  // Initialize and control video playback - UPDATED TO HANDLE MIXED MEDIA
  useEffect(() => {
    console.log('🎬 Setting up media playback for slide:', activeSlide);
    
    // Function to handle video and image playback
    const handleMediaPlayback = () => {
      const mediaItems = getHeroVideos();
      mediaItems.forEach((media, index) => {
        const mediaRef = videoRefs[index].current;
        if (mediaRef && media.type === "video") {
          if (index === activeSlide) {
            // Play the active video
            console.log(`🎬 Playing video ${index}: ${media.src}`);
            mediaRef.play().catch(error => {
              // Expected during rapid slide transitions when a play is interrupted by pause.
              if (error?.name !== 'AbortError') {
                console.log(`Video ${index} play error:`, error);
              }
            });
          } else {
            // Pause other videos
            if (!mediaRef.paused) {
              console.log(`🎬 Pausing video ${index}`);
              mediaRef.pause();
              mediaRef.currentTime = 0;
            }
          }
        } else if (media.type === "image") {
          // For images, we don't need to do anything special for playback
          // The image will be shown/hidden based on CSS classes
          console.log(`🖼️ Image slide ${index}: ${media.src}`);
        } else if (media.type === "text") {
          // For text slides, we don't need to do anything special for playback
          // The text background will be shown/hidden based on CSS classes
          console.log(`📝 Text slide ${index}: ${media.title}`);
        } else if (media.type === "custom") {
          console.log(`✨ Custom slide ${index}: ${media.slideKey}`);
        }
      });
    };
    
    // Handle media playback when slide changes
    handleMediaPlayback();
    
    // Auto-advance slides every 8 seconds
    const slideTimer = setInterval(() => {
      console.log('🔄 Auto-advancing to next slide');
      nextSlide();
    }, 8000);
    
    return () => {
      clearInterval(slideTimer);
      console.log('🧹 Cleaning up media playback');
    };
  }, [activeSlide]);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxBgRef.current) {
        const scrolled = window.scrollY;
        parallaxBgRef.current.style.transform = `translateY(${scrolled * 0.3}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCardClick = (path, cardId) => {
    setActiveCard(cardId);
    
    setTimeout(() => {
      history.push(path);
    }, 600);
  };

  const handleHomeServiceClick = (service) => {
    setActiveCard(service.id);

    setTimeout(() => {
      if (service.route) {
        window.open(service.route, '_blank', 'noopener,noreferrer');
      } else {
        history.push('/services');
      }
    }, 600);
  };

  const handleContentHover = (sectionId) => {
    console.log("Content hover:", sectionId);
    setHoverSection(sectionId);
  };

  const handleContentHoverEnd = () => {
    console.log("Content hover end");
    setHoverSection(null);
  };

  return (
    <div className="home-main-container">
      {/* PWA Install Banner - Below Navbar */}
      {shouldShowInstallBanner() && (
        <div className="pwa-install-banner">
          <div className="pwa-banner-content">
            <div className="pwa-banner-text">
              <span className="pwa-banner-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="#6366f1"/>
                  <path d="M12 8L12 16M8 12L12 16L16 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <div className="pwa-banner-message">
                <strong>Install Vardaan Global App</strong>
                <p>Get faster access and work offline!</p>
              </div>
            </div>
            <div className="pwa-banner-actions">
              <button 
                className="pwa-install-button" 
                onClick={handleInstallClick}
                aria-label="Install Vardaan Global App"
              >
                <span className="pwa-install-text">Get the App</span>
              </button>
              <button 
                className="pwa-banner-close" 
                onClick={handleBannerClose}
                aria-label="Close banner"
              >
                <span className="pwa-close-icon">×</span>
              </button>
            </div>
          </div>
        </div>
      )}

      <section 
        className="hero-lion-section"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div className="video-overlay">
          {/* Render all media (videos, images, and text slides) */}
          {getHeroVideos().map((media, index) => {
            if (media.type === "video") {
              return (
                <video 
                  key={`video-${index}-${media.src}`} // Force re-render when src changes
                  ref={videoRefs[index]}
                  className={`hero-background-video ${activeSlide === index ? "active" : ""}`}
                  muted 
                  loop
                  playsInline
                  preload="metadata"
                  onClick={handleHeroClick}
                  onLoadStart={() => {
                    console.log(`🎬 Video ${index} load started: ${media.src}`);
                  }}
                  onLoadedMetadata={() => {
                    console.log(`🎬 Video ${index} metadata loaded: ${media.src}`);
                    // Only auto-play if this is the active slide
                    if (index === activeSlide) {
                      console.log(`🎬 Auto-playing video ${index} after metadata load`);
                      videoRefs[index].current?.play().catch(error => {
                        if (error?.name !== 'AbortError') {
                          console.log(`Auto-play error for video ${index}:`, error);
                        }
                      });
                    }
                  }}
                  onCanPlay={() => {
                    console.log(`🎬 Video ${index} can play: ${media.src}`);
                  }}
                  onPlay={() => {
                    console.log(`🎬 Video ${index} started playing`);
                  }}
                  onPause={() => {
                    console.log(`🎬 Video ${index} paused`);
                  }}
                  onError={(e) => {
                    if (media.videoName) {
                      setFailedVideoSlides((prev) => {
                        if (prev[media.videoName]) {
                          return prev;
                        }
                        return { ...prev, [media.videoName]: true };
                      });
                    }
                  }}
                >
                  <source src={media.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              );
            } else if (media.type === "image") {
              return (
                <img
                  key={`image-${index}-${media.src}`}
                  ref={videoRefs[index]} // Using same ref system for consistency
                  className={`hero-background-image ${activeSlide === index ? "active" : ""} ${media.customClass || ""}`}
                  src={media.src}
                  alt={media.title}
                  onClick={handleHeroClick}
                  onLoad={() => {
                    console.log(`🖼️ Image ${index} loaded: ${media.src}`);
                  }}
                  onError={(e) => {
                    console.error(`❌ Image ${index} error:`, e.target.src);
                  }}
                />
              );
            } else if (media.type === "text") {
              return (
                <div
                  key={`text-${index}`}
                  ref={videoRefs[index]}
                  className={`hero-background-text ${activeSlide === index ? "active" : ""} ${media.customClass || ""}`}
                />
              );
            } else if (media.type === "custom") {
              return (
                <div
                  key={`custom-${index}-${media.slideKey}`}
                  ref={videoRefs[index]}
                  className={`hero-custom-slide ${activeSlide === index ? "active" : ""}`}
                >
                  {media.slideKey === "intechsante" && <IntechsanteCarouselSlide />}
                  {media.slideKey === "grc-webinar" && <GrcWebinarCarouselSlide />}
                </div>
              );
            }
            return null;
          })}
          
          {/* Overlay content with dynamic titles */}
          {getHeroVideos()[activeSlide].type !== "custom" && (
          <div className={`video-overlay-content ${getHeroVideos()[activeSlide].customClass ? getHeroVideos()[activeSlide].customClass + '-overlay' : ''} ${getHeroVideos()[activeSlide].src && getHeroVideos()[activeSlide].src.includes('GRCS.jpg') ? 'riskavaire-promo-slide-overlay' : ''}`} onClick={handleHeroClick}>
            {/* Show logo for summit slide above title */}
            {(['home-slide', 'summit-slide', 'tprm-slide', 'product-slide', 'fost-hr-slide'].includes(getHeroVideos()[activeSlide].customClass)) && getHeroVideos()[activeSlide].logo && (
              <div className={`hero-summit-logo-container ${getHeroVideos()[activeSlide].brandText ? 'hero-brand-lockup' : ''}`}>
                <img 
                  src={getHeroVideos()[activeSlide].logo} 
                  alt={getHeroVideos()[activeSlide].customClass === 'home-slide' ? "Vardaan Global Logo" : "Company Logo"}
                  className={`hero-summit-logo ${getHeroVideos()[activeSlide].logoClass || ''}`}
                />
                {getHeroVideos()[activeSlide].brandText && (
                  <span className="hero-brand-text">{getHeroVideos()[activeSlide].brandText}</span>
                )}
              </div>
            )}
            <h1 className="hero-lion-title">{getHeroVideos()[activeSlide].title}</h1>
            {getHeroVideos()[activeSlide].titleSecondary && (
              getHeroVideos()[activeSlide].logo ? (
                <div className="hero-partner-logo-container">
                  <img 
                    src={getHeroVideos()[activeSlide].logo} 
                    alt="Partner Logo" 
                    className="hero-partner-logo"
                  />
                </div>
              ) : (
                <h1 className="hero-lion-title-secondary">{getHeroVideos()[activeSlide].titleSecondary}</h1>
              )
            )}
            {getHeroVideos()[activeSlide].subtitle && (
              <p className="hero-lion-subtitle">{getHeroVideos()[activeSlide].subtitle}</p>
            )}
            
            {/* Show description for text-type slides */}
            {getHeroVideos()[activeSlide].description && (
              <p className="hero-lion-description">{getHeroVideos()[activeSlide].description}</p>
            )}
            
            {/* Show tagline for promo slides */}
            {getHeroVideos()[activeSlide].tagline && (
              <p className="hero-lion-tagline">{getHeroVideos()[activeSlide].tagline}</p>
            )}
            
            {/* Show CTA button for slides with path */}
            {getHeroVideos()[activeSlide].path && (
              <button 
                className="hero-cta-button"
                onClick={(e) => {
                  e.stopPropagation();
                  const currentSlide = getHeroVideos()[activeSlide];
                  if (currentSlide.isExternal) {
                    window.open(currentSlide.path, '_blank', 'noopener,noreferrer');
                  } else {
                    history.push(currentSlide.path);
                  }
                }}
              >
                {getHeroVideos()[activeSlide].customClass === 'summit-slide' 
                  ? 'Visit Summit Website' 
                  : getHeroVideos()[activeSlide].customClass === 'riskavaire-promo-slide'
                  ? 'Contact Us'
                  : (getHeroVideos()[activeSlide].isExternal ? 'Learn More' : 'Learn More')}
              </button>
            )}
            </div>
          )}
          
          {/* Navigation controls */}
          <div className="hero-controls">
            <div className="hero-dots">
              {getHeroVideos().map((_, index) => (
                <button 
                  key={index}
                  className={`hero-dot ${activeSlide === index ? "active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    goToSlide(index);
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="about-section-img">
        <div className="about-img-grid">
          <div className="about-img-left">
            
            <h1 className="about-img-title">
              Decades of <span className="about-img-highlight">Domain expertise</span> <span className="about-img-no-break">shaping</span> the future of <span className="about-img-no-break">finance</span> and technology
            </h1>
            <AboutAnimatedDescription text="We have built a strong foundation in asset assessment, technical due diligence, and enterprise valuation. Our journey has evolved to embrace future-ready capabilities in data science, artificial intelligence, cybersecurity, ERP solutions, digital transformation, camera vision-based AI, and broader IT services." />
          </div>
          <div className="about-img-right">
            <div className="about-img-blob">
              <img 
                src={getImageUrl('Finance 1.jpg', financeImage)} 
                alt="About us" 
                className="about-img-main"
                loading="eager"
                fetchPriority="high"
                decoding="async"
                onError={(e) => {
                  logger.error('Image failed to load:', e.target.src);
                }}
              />
              <div className="about-img-dots"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Metrics Section */}
      <section className="metrics-section">
        <div className="metrics-container">
          <div className="metrics-grid">
            <div className="metric-item">
              <div className="metric-number">22</div>
              <div className="metric-label">Countries Served</div>
              <div className="metric-description">Global presence across multiple continents</div>
            </div>
            <div className="metric-item">
              <div className="metric-number">$50B</div>
              <div className="metric-label">Customers Revenue</div>
              <div className="metric-description">Total revenue generated for our clients</div>
            </div>
            <div className="metric-item">
              <div className="metric-number">500+</div>
              <div className="metric-label">Projects Completed</div>
              <div className="metric-description">Successful implementations and deliveries</div>
            </div>
          </div>
        </div>
      </section>
  
      {/* Capabilities Section */}
      <section className="capabilities-section">
        <div className="capabilities-grid">
          <div className="capability-item">
            <div className="capability-head">
              <div className="capability-icon" style={{ backgroundColor: '#1e3a5f' }}>
                <FaRocket />
              </div>
              <h3 className="capability-title">Future-Ready Capabilities</h3>
            </div>
            <p className="capability-text">
              Data science, AI, cybersecurity, ERP, digital transformation, and computer vision — helping 500+ customers stay resilient, scalable, and ready for tomorrow.
            </p>
          </div>

          <div className="capability-item">
            <div className="capability-head">
              <div className="capability-icon" style={{ backgroundColor: '#d9534f' }}>
                <FaBrain />
              </div>
              <h3 className="capability-title">AI at the Core</h3>
            </div>
            <p className="capability-text">
              From GRC intelligence and agentic automation to vision AI and digital workers — AI embedded across platforms for measurable impact to 50M+ users.
            </p>
          </div>

          <div className="capability-item">
            <div className="capability-head">
              <div className="capability-icon" style={{ backgroundColor: '#0d7069' }}>
                <FaGlobe />
              </div>
              <h3 className="capability-title">Global Expertise, Local Context</h3>
            </div>
            <p className="capability-text">
              10+ countries, 100+ managed services contracts and 28+ records managed — global scale with deep regional regulatory and industry understanding.
            </p>
          </div>

          <div className="capability-item">
            <div className="capability-head">
              <div className="capability-icon" style={{ backgroundColor: '#1e3a5f' }}>
                <FaHandshake />
              </div>
              <h3 className="capability-title">Expert & Partner Ecosystem</h3>
            </div>
            <p className="capability-text">
              In-house delivery teams complemented by 2,500+ industry partner experts — seamless, end-to-end execution across enterprise and public sector.
            </p>
          </div>

          <div className="capability-item">
            <div className="capability-head">
              <div className="capability-icon" style={{ backgroundColor: '#5a32a3' }}>
                <FaIndustry />
              </div>
              <h3 className="capability-title">Industry-Specific Solutions</h3>
            </div>
            <p className="capability-text">
              Purpose-built across 20+ technology towers — Banking & Financial Services, Manufacturing, Healthcare, Retail, Government, and Smart Cities.
            </p>
          </div>
        </div>
      </section>

      <section className="ps-marquee-section">
        <div className="ps-marquee-header">
          <span className="ps-eyebrow">Our Products & Services</span>
          <h2 className="ps-heading">One ecosystem. <span className="ps-heading-accent">Endless capability.</span></h2>
          <p className="ps-subheading">
            Flagship platforms and expert services working together — from GRC and workforce
            management to AI, data, and cybersecurity.
          </p>
        </div>

        <div className="ps-marquee">
          <div className="ps-marquee-track ps-marquee-track--left">
            {[...productMarqueeItems, ...productMarqueeItems].map((item, idx) => (
              <button
                key={`product-${idx}`}
                type="button"
                className="ps-product-card"
                onClick={() => {
                  if (item.isExternal) {
                    window.open(item.path, '_blank', 'noopener,noreferrer');
                  } else {
                    history.push(item.path);
                  }
                }}
              >
                <span className="ps-product-logo-wrap">
                  <img src={item.logo} alt={item.name} className="ps-product-logo" />
                </span>
                <span className="ps-product-info">
                  <span className="ps-product-name">{item.name}</span>
                  <span className="ps-product-tagline">{item.tagline}</span>
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="ps-marquee">
          <div className="ps-marquee-track ps-marquee-track--right">
            {[...portfolioItems, ...portfolioItems].map((item, idx) => (
              <button
                key={`service-${idx}`}
                type="button"
                className="ps-service-chip"
                onClick={() => history.push('/services')}
              >
                <span className="ps-service-icon">{item.icon}</span>
                <span className="ps-service-label">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="portfolio-section">
  <h2 className="portfolio-title">Portfolio</h2>
  <div className="portfolio-cards">
    
    <div className="portfolio-row">
      <div 
        className={`portfolio-card-large ${activeCard === 'ai-products' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/grc', 'ai-products')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('AI Products.jpg', fallbackImages['AI Products.jpg'])} 
            alt="AI Products"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">AI PRODUCTS</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-large ${activeCard === 'data-services' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/data-services', 'data-services')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Data Services.avif', fallbackImages['Data Services.avif'])} 
            alt="Data Services"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">DATA SERVICES</h3>
          </div>
        </div>
      </div>
    </div>
    
    <div className="portfolio-row">
      <div 
        className={`portfolio-card-small ${activeCard === 'ai-consulting' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/ai-consulting', 'ai-consulting')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Ai Consulting.jpg', fallbackImages['Ai Consulting.jpg'])} 
            alt="AI Consulting"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">AI CONSULTING SERVICE</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-small ${activeCard === 'cybersecurity' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/cybersecurity-services', 'cybersecurity')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Cyber security.avif', fallbackImages['Cyber security.avif'])} 
            alt="Cybersecurity"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">CYBERSECURITY SERVICE</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-small ${activeCard === 'erp' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/erp-services', 'erp')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('ERP.jpg', fallbackImages['ERP.jpg'])} 
            alt="ERP Implementation"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">ERP IMPLEMENTATION & MAINTENANCE</h3>
          </div>
        </div>
      </div>
    </div>
    
    <div className="portfolio-row">
      <div 
        className={`portfolio-card-large ${activeCard === 'techno-financial' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/techno-financial', 'techno-financial')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Techno Financial Services.webp', fallbackImages['Techno Financial Services.webp'])} 
            alt="Techno Financial Services"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">TECHNO FINANCIAL SERVICES</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-large ${activeCard === 'digital-workers' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/robotics', 'digital-workers')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Digital Workers.jpg', fallbackImages['Digital Workers.jpg'])} 
            alt="Digital Workers"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">DIGITAL WORKERS</h3>
          </div>
        </div>
      </div>
    </div>
    
    <div className="portfolio-row">
      <div 
        className={`portfolio-card-small ${activeCard === 'vision' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/ai-consulting', 'vision')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Vision.jpg', fallbackImages['Vision.jpg'])} 
            alt="AI Based Vision Solutions"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">AI BASED VISION SOLUTIONS</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-small ${activeCard === 'it-solutions' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/data-services', 'it-solutions')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Corporate.jpg', fallbackImages['Corporate.jpg'])} 
            alt="IT Solutions & Services"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">IT SOLUTIONS & SERVICES</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-small ${activeCard === 'training' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/training-services', 'training')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('Training.webp', fallbackImages['Training.webp'])} 
            alt="Training"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">TRAINING</h3>
          </div>
        </div>
      </div>
    </div>
    
    <div className="portfolio-row">
      <div 
        className={`portfolio-card-large ${activeCard === 'ds-training' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/training-services', 'ds-training')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('training-ds.webp', fallbackImages['training-ds.webp'])} 
            alt="Data Science Training"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">DATA SCIENCE TRAINING</h3>
          </div>
        </div>
      </div>
      <div 
        className={`portfolio-card-large ${activeCard === 'cyber-training' ? 'active' : ''}`} 
        onClick={() => handleCardClick('/training-services', 'cyber-training')} 
        style={{cursor: 'pointer'}}
      >
        <div className="portfolio-card-image">
          <img 
            src={getImageUrl('training-cyber.jpg', fallbackImages['training-cyber.jpg'])} 
            alt="Cybersecurity Training"
            loading="lazy"
            decoding="async"
          />
          <div className="portfolio-card-overlay">
            <h3 className="portfolio-card-heading">CYBERSECURITY TRAINING</h3>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</section>
     
<section className="what-we-do-section">
  <h2 className="what-we-do-title">What We Do</h2>
  
  {homeServices.map((service) => (
    <div className="what-we-do-container" key={service.id}>
      <div
        className={`what-we-do-image-side ${activeCard === service.id ? 'active' : ''} ${hoverSection === service.id ? 'content-hover' : ''}`}
        onClick={() => handleHomeServiceClick(service)}
        style={{cursor: 'pointer'}}
      >
        <img
          src={service.image}
          alt={service.title}
          className="what-we-do-image"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div
        className="what-we-do-content-side"
        onClick={() => handleHomeServiceClick(service)}
        onMouseEnter={() => handleContentHover(service.id)}
        onMouseLeave={handleContentHoverEnd}
        style={{cursor: 'pointer'}}
      >
        <h3 className="what-we-do-heading">{service.title}</h3>
        <p className="what-we-do-description">{service.description}</p>
        <button className="what-we-do-btn" onClick={(e) => { e.stopPropagation(); handleHomeServiceClick(service); }}>Learn More</button>
      </div>
    </div>
  ))}

</section>

      <div className="footer-spacing"></div>
      <Footer />
      
      {/* iOS Install Prompt Modal */}
      {showIOSPrompt && <IOSInstallPrompt onClose={handleIOSPromptClose} />}
      {showAndroidPrompt && <AndroidInstallPrompt onClose={handleAndroidPromptClose} />}
    </div>
  );
};

export default Home;